import { ValueObject } from '../../../shared/models/ValueObject';

/**
 * 이메일 값 객체
 */
export class Email extends ValueObject<string> {
  private readonly _value: string;

  constructor(value: string) {
    super();
    this.validate(value);
    this._value = value.toLowerCase();
  }

  get value(): string {
    return this._value;
  }

  private validate(value: string): void {
    if (!value) {
      throw new Error('이메일은 비어있을 수 없습니다');
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) {
      throw new Error('올바른 이메일 형식이 아닙니다');
    }
  }

  protected equalsCore(vo: Email): boolean {
    return this._value === vo._value;
  }

  protected copy(): Email {
    return new Email(this._value);
  }

  toString(): string {
    return this._value;
  }

  /**
   * 도메인 추출
   */
  getDomain(): string {
    return this._value.split('@')[1];
  }

  /**
   * 로컬 파트 추출
   */
  getLocalPart(): string {
    return this._value.split('@')[0];
  }

  /**
   * 팩토리 메서드
   */
  static create(value: string): Email {
    return new Email(value);
  }
}